"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex-auto" };
const _hoisted_2 = { class: "font-semibold leading-snug" };
const _hoisted_3 = { class: "leading-snug" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Close", -1);
const vue_3 = require("vue");
const AlertType_1 = require("../../src/types/AlertType");
const Alerts_1 = require("../../stores/Alerts");
const ButtonIcon_vue_1 = __importDefault(require("../ButtonIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'Alert',
    props: {
        alert: null
    },
    setup(__props) {
        const props = __props;
        const store = (0, Alerts_1.useAlertsStore)();
        const blobClass = (0, vue_3.computed)(() => {
            switch (props.alert.type) {
                case AlertType_1.AlertType.Success:
                    return 'bg-green-300';
                case AlertType_1.AlertType.Error:
                    return 'bg-red';
                case AlertType_1.AlertType.Warning:
                    return 'bg-yellow';
                case AlertType_1.AlertType.Info:
                default:
                    return 'bg-teal';
            }
        });
        const title = (0, vue_3.computed)(() => {
            if (props.alert.title) {
                return props.alert.title;
            }
            switch (props.alert.type) {
                case AlertType_1.AlertType.Success:
                    return 'Success!';
                case AlertType_1.AlertType.Error:
                    return 'Error!';
                case AlertType_1.AlertType.Warning:
                    return 'Warning!';
                case AlertType_1.AlertType.Info:
                default:
                    return 'Info!';
            }
        });
        function close() {
            store.remove(props.alert.key);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)(__props.alert.url ? 'a' : 'div'), {
                href: __props.alert.url,
                class: "px-5 py-2 rounded-3xl bg-beige-100 flex items-center gap-5"
            }, {
                default: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", {
                        class: (0, vue_2.normalizeClass)(["w-2 h-full rounded-md flex-shrink-0", (0, vue_2.unref)(blobClass)])
                    }, null, 2),
                    (0, vue_2.createElementVNode)("span", _hoisted_1, [
                        (0, vue_2.createElementVNode)("p", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(title)), 1),
                        (0, vue_2.createElementVNode)("p", _hoisted_3, (0, vue_2.toDisplayString)(__props.alert.message), 1)
                    ]),
                    (0, vue_2.createElementVNode)("button", {
                        onClick: (0, vue_2.withModifiers)(close, ["prevent"]),
                        class: "button button-outlined button-mutedpurple-800 has-icon"
                    }, [
                        (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                        _hoisted_5
                    ], 8, _hoisted_4)
                ]),
                _: 1
            }, 8, ["href"]));
        };
    }
});
